import React from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface QueryInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
  'data-testid'?: string;
}

const QueryInput: React.FC<QueryInputProps> = ({
  value,
  onChange,
  onSubmit,
  isLoading,
  'data-testid': testId,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <Box display="flex" gap={2} data-testid={testId}>
      <TextField
        fullWidth
        placeholder="Ask a question about your documents..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
        variant="outlined"
        size="small"
        aria-label="Query input"
        data-testid={`${testId}-field`}
      />
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isLoading || !value.trim()}
        startIcon={isLoading ? <CircularProgress size={18} /> : <SearchIcon />}
        aria-label="Submit query"
        data-testid={`${testId}-submit-button`}
      >
        {isLoading ? 'Searching...' : 'Search'}
      </Button>
    </Box>
  );
};

export default QueryInput;
